<div class="actiuni-card-container action-card-{{actionType}}" [class.selected]="selectedClass()">
    <div class="card-status">
        <div class="card-header">
            <span class="title">{{ title }}</span>
            <span class="description" *ngIf="(actionType == 'finalizare')">{{ description }}</span>
        </div>
    </div>
    <div class="card-content" *ngIf="['finalizare'].includes(actionType) && data?.validated_date !== null">
        <div class="card-content__header">
            <span class="user"><i class="fa-regular fa-user"></i> {{ data?.validated_user_name }}</span>
            <span class="date"><i class="fa-regular fa-calendar-check"></i> {{ data?.validated_date }}</span>
            <span class="date"><i class="fa-regular fa-comments"></i> {{ data?.validated_summary }}</span>
        </div>
        <div class="card-content__body">
            <div class="card-content__body__text">
                <i class="fa-regular fa-message"></i> {{ data?.validated_obs }}
            </div>
        </div>
    </div>
    <div class="card-actions">
        <div class="card-image">
            <mat-icon [ngStyle]="{'color': iconColor}">{{ iconName }}</mat-icon>
        </div>
        <div class="card-button">
            <button *ngIf="
                    (actionType == 'finalizare' && permissionsService.hasPermission('indoc-module.registratura_documents.document-view.inchidere-lucrare'))
                " type="button" mat-raised-button color={{btnColor}} class="action-button" [disabled]="
                    (actionType == 'finalizare' && (data?.validated_date !== null || data?.allow_finalize !== 1)) 
				" (click)="onButtonClick()">{{ actionText }}</button>
        </div>
    </div>
    <div class="card-footer" *ngIf="
        (actionType == 'finalizare' && permissionsService.hasPermission('indoc-module.registratura_documents.document-view.resetare-finalizare') && data?.validated_date !== null)
	">
        <div class="card-button">
            <button type="button" mat-raised-button color={{btnColor}} class="action-button w-100"
                (click)="onButtonResetClick()"><mat-icon class="resetIcon"
                    style="color: 'red'">report_problem</mat-icon> Reset</button>
        </div>
    </div>
</div>